import { useLazyGetAbsenceStatsQuery } from "../api/absenceReportApiSlice";
import TimeOffCalendar from "../views/TimeOffCalendar";

export default function AbsencesCalendar() {

    const [trigger, {
        data: absenceReportsUi,
        isSuccess: isAbsentsSuccess,
        isFetching: isAbsentsFetching,
        isError: isAbsentsError,
        error: absentsError,

    }] = useLazyGetAbsenceStatsQuery()

    // Funzione per gestire il cambio mese
    const handleMonthChange = (start, end) => {
        console.log("MonthChanged")
        trigger({ start, end })
    };

    return <TimeOffCalendar
        data={isAbsentsSuccess ? absenceReportsUi.absences : null}
        isFetching={isAbsentsFetching}
        isSuccess={isAbsentsSuccess}
        refetch={handleMonthChange}
    />
}